const typographyFormParamUser = {
  text: 'Infos do Usuário',
  inspector: 'Vistoriador',
  inspectorHelperText: 'O acesso de Vistoriador permite apenas criar serviços e editar ações pelas quais é responsável. Todas as demais criações e edições são bloqueadas.',
};

export default typographyFormParamUser;
